// setActiveStreamId.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import resetLiveStream from '../action/resetLiveStream.js';
import getOperationData from '../selector/getOperationData.js';

/**
 * Set active stream id
 * @kind action
 * @param {string|undefined} {activeStreamId} - active stream id.
 * @return {Promise} Action promise.
 */
const setActiveStreamId =
  ({ activeStreamId }) =>
  async (dispatch, getState) => {
    const currentStreamId = getOperationData(
      getState(),
      ['liveStream'],
      'activeStreamId'
    );
    if (currentStreamId && currentStreamId !== activeStreamId) {
      dispatch(
        resetLiveStream({ streamId: currentStreamId, isLeaveLivestream: true })
      );
    }
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream'],
        data: {
          activeStreamId: activeStreamId ? activeStreamId : undefined,
          startTime: activeStreamId ? Date.now() : undefined,
        },
      },
    });
  };

export default setActiveStreamId;
